module.exports = __webpack_public_path__ + "img/VERIFIED.86083e7c.svg";